<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon" :title="$t('general.back')" @click.prevent="backButton"><i class="ti-arrow-left"></i></a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-6 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{ $t('marketingPromos.firstname') }}</label>
                  <input type="text"
                    placeholder="John"
                    v-validate="modelValidate.firstname"
                    v-model="model.firstname"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{ $t('marketingPromos.lastname') }}</label>
                  <input type="text"
                    placeholder="Doe"
                    v-validate="modelValidate.lastname"
                    v-model="model.lastname"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input type="text"
                    placeholder="johndoe@gmail.com"
                    v-validate="modelValidate.email"
                    v-model="model.email"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{ $t('kds.loginCode') }}</label>
                  <input type="number"
                    placeholder="1234"
                    v-validate="modelValidate.login_code"
                    v-model="model.login_code"
                    class="form-control">
                    <small class="text-danger" v-if="errors.has('login_code')">
                      {{$t('kds.loginCodeNotUnique')}}
                    </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      PSwitch,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    data () {
      return {
        id: this.value || this.tableId,
        locations: [],
        model: {
          'id': 0,
          'role': 'KDS_OPERATOR',
          'language': 'en',
          'loyalty_points': 0,
          'has_push_notifications': 0,
          'has_email_notifications': 0,
          'is_verified': 0,
          'is_created_from_admin': 0,
          'is_siteadmin': 0,
          'firstname': null,
          'lastname': null,
          'login_code': null
        },
        modelValidate: {
          firstname: {required: true},
          lastname: {required: true},
          email: {
            required: true,
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          },
          login_code: {
            required: true,
            regex: /^[0-9]{4}$/
          }
        },
        loading: true
      }
    },
    methods: {
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        var id = this.id || this.route.params.id
        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/kds/user/' + id, 'GET', data, (response) => {
            if (response.status) {
              this.model = response.data.kds_user
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.loading = true
        this.model.login_code = this.model.login_code
        let data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'kds_user': this.model
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/kds/user/' + id
          request = 'PUT'
        } else {
          url = '/kds/user/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/screens/kds/users/' + response.data.kds_user.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/kds/user/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push({path: '/screens/kds', query: { tabIndex: 1, openUsers: true }})
      }
    }
  }
</script>
<style>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Users/KdsUserForm.vue